import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import React from 'react';
import { LoggedOutProductLibraryContainsItem } from '../../types/library';
import LibraryL4PageLoggedOut from './LibraryL4PageLoggedOut';

type L3Props = {
  l3: LoggedOutProductLibraryContainsItem;
  l1Id: string;
  l2Id: string;
  targetId?: string;
};

/**
 * LibraryL3LevelLoggedOut.
 * @param props
 * @returns
 */
const LibraryL3LevelLoggedOut = (props: L3Props) => {
  const { l3, l1Id, l2Id, targetId } = props;

  return (
    <Box cn="p-8" data-id={l3.name + l3.type} key={l3.id}>
      <H3
        cn="pb-2 border-b-1 border-slate-200"
        data-testid="library-topic-box-l3-level"
      >
        {l3.displayName || l3.name}
      </H3>

      <Flex cn="flex-wrap py-8 gap-8 justify-between">
        {l3?.contains?.map((l4: LoggedOutProductLibraryContainsItem) => {
          return (
            <LibraryL4PageLoggedOut
              key={'l4' + l4.id}
              l1Id={l1Id}
              l2Id={l2Id}
              l3Id={l3.id}
              l4={l4}
              {...(targetId && { targetId })}
            />
          );
        })}
      </Flex>
    </Box>
  );
};

export default LibraryL3LevelLoggedOut;
